<ion-list>
    <ion-list-header>
        <span translate>SagaMobile.UA.VehicleSettings.Label</span>
    </ion-list-header>
    <ion-item>
        <ion-label><span translate>SagaMobile.UA.VehicleSettings.Extanded</span></ion-label>
        <ion-toggle [(ngModel)]="options.extended"></ion-toggle>
    </ion-item>
</ion-list>
